<app-loader></app-loader>

<app-header *ngIf="isDisplay" [isDisplayMenuButton]="isShowLogoutAndMenuIcon" [isFormBlur]="isFormBlur"
    [userInfo]="userInfo" (MenuClick)="isSidebarOpen=!isSidebarOpen" (LogoutClick)="logout()"
    (toggleGlobalModal)="toggleGlobalModal($event)"></app-header>

<app-sidebar *ngIf="isDisplay" [IsSidebarOpen]="isSidebarOpen"></app-sidebar>

<div [class.blur-form]="isFormBlur" style="height: 100%;">
    <router-outlet></router-outlet>
</div>

<app-footer *ngIf="isDisplay"></app-footer>

<style id="antiClickjack">
    body {
        display: none !important;
    }
</style>

<script type="text/javascript" nonce="cd90d3070658eb370a6e152dc25dc04f">
    if (self === top) {
        var antiClickjack = document.getElementById("antiClickjack");
        antiClickjack.parentNode.removeChild(antiClickjack);
    } else {
        top.location = self.location;
    }
</script>